<div *ngIf="{scheduleData: scheduleData$ | async,
    quoteLines: quoteLines$ | async,
    dropdowns: serviceLaneDropdownsFacade.serviceAppointmentCaseDropdowns$ | async,
    currentEmployee: authenticatedEmployee$ | async} as data" fxLayout="row" fxLayoutAlign="start start">
  <div fxLayout="row" fxFlex class="content" fxLayoutAlign="start start"
    *ngIf="data?.scheduleData?.vehicle?.deliveryDate !== null && !data?.scheduleData?.loadFailed;
      else menuUnavailable">
    <div fxLayout="column" fxFlex [@flyOutIn]="dank">
      <ng-container id="previous-container">
        <div id="previous-header" fxLayoutAlign="space-between start">
          <h2>Previous Services</h2>
          <button mat-icon-button class="mr-1" (click)="previousUi.collapsed = !previousUi.collapsed">
            <mat-icon>{{previousUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
          </button>
        </div>

        <ng-container id="previous-data" *ngIf="!previousUi.collapsed">
          <div class="my-2 mx-2" fxLayoutAlign="space-between center">
            <span class="mat-subheading font-medium mb-0">Factory Recommended</span>
          </div>

          <ng-container *ngIf="data?.scheduleData?.toyotaMenuData?.previous?.factoryRecommended; else loading">
            <div fxLayout="column"
              *ngFor="let menuItem of data.scheduleData?.toyotaMenuData.previous.factoryRecommended | orderBy: [''];let i=index"
              class="testing-concept" class="qcontainer"
              style="overflow:hidden;page-break-before:always;border-radius:8px;padding:8px 16px;background-color:#FFF;margin: 12px 12px 12px 16px;">
              <div fxLayout="row" fxLayoutAlign="space-between start">
                <div class="flex flex-col">
                  <div fxLayoutAlign="start center">
                    <h3 class="mat-body-2">{{menuItem.serviceGroupName}}</h3>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)" class="flex flex-row"
                    fxLayoutAlign="start center">
                    <div class="accepted-service"></div>
                    <span class="mat-caption secondary-text">Accepted on current transaction</span>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="declined-service"></div>
                    <span class="mat-caption secondary-text">Declined on current transaction</span>
                  </div>
                </div>
                <div *ngIf="menuItem.serviceGroupRate; else noPricing">
                  <h3 class="mat-body-1 secondary-text">{{ menuItem.serviceGroupRate | currency}}</h3>
                </div>
                <ng-template #noPricing>
                  <h3 class="mat-body-1 secondary-text">N/A</h3>
                </ng-template>
              </div>
              <ng-container *ngIf="!menuItem.collapsed">
                <h4 class="mat-body-1 secondary-text" *ngIf="menuItem.source === 'Kms'; else age">Sourced via odometer
                  reading.</h4>
                <ng-template #age>
                  <h4 class="mat-body-1 secondary-text">Sourced via date of service.</h4>
                </ng-template>
                <ul *ngIf="menuItem.services; else loadingServices">
                  <li *ngFor="let service of menuItem.services" [@fadeInOut] class="mat-body-1 secondary-text">
                    {{service}}</li>
                </ul>
              </ng-container>
              <ng-template #loadingServices>
                <ul>
                  <li class="animated-background secondary-text h-4 w-3/5 my-1.5 mx-0 rounded"></li>
                  <li class="animated-background secondary-text h-4 w-2/5 my-1.5 mr-0 rounded"></li>
                </ul>
              </ng-template>
              <mat-divider class="my-3 ml-1"></mat-divider>
              <div class="flex flex-row" fxLayoutAlign="space-between center">
                <div>
                  <mat-form-field appearance="fill" class="text-sm">
                    <mat-label [ngClass]="{'text-red-700': !previousFactoryRecommendedTechSelection[i]}">Tech/Tech Group
                    </mat-label>
                    <mat-select name="technicianGroupId" [(ngModel)]="previousFactoryRecommendedTechSelection[i]"
                      required
                      [disabled]="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) || checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)">
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Tech Groups
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicianGroups | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: 'description'"
                          [value]="tg.id">
                          {{tg.description}}
                        </mat-option>
                      </mat-optgroup>
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Technicians
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicians | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | sortNamesBy: ['lastName']"
                          [value]="tg.associateId">
                          {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                        </mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.serviceGroup); else itemActioned ">
                  <button mat-icon-button
                    (click)="selectDeclinedReason(menuItem, previousFactoryRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!previousFactoryRecommendedTechSelection[i]"
                    [ngClass]="previousFactoryRecommendedTechSelection[i]? 'text-red-700' : 'text-grey-400'">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button mat-icon-button
                    (click)="acceptService(menuItem, previousFactoryRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!previousFactoryRecommendedTechSelection[i]"
                    [ngClass]="previousFactoryRecommendedTechSelection[i]? 'text-green-800' : 'text-grey-400'">
                    <mat-icon>check</mat-icon>
                  </button>

                </div>

                <ng-template #itemActioned>
                  <ng-container *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)">
                    <button mat-icon-button (click)="removeAcceptedService(menuItem, data.quoteLines)"
                      class="text-green-800">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup);">
                    <button mat-icon-button (click)="removeDeclinedService(menuItem, data.quoteLines)" class="text-red">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>
                </ng-template>
              </div>

            </div>
          </ng-container>

          <div class="my-2 mx-2" fxLayoutAlign="space-between center">
            <span class="mat-subheading-2 font-medium mb-0">Dealer Recommended</span>
          </div>

          <ng-container *ngIf="data?.scheduleData?.toyotaMenuData?.previous?.dealerRecommended; else loading">
            <div fxLayout="column"
              *ngFor="let menuItem of data.scheduleData?.toyotaMenuData.previous.dealerRecommended | orderBy: [''];let i=index"
              class="testing-concept" class="qcontainer"
              style="overflow:hidden;page-break-before:always;border-radius:8px;padding:8px 16px;background-color:#FFF;margin: 12px 12px 12px 16px;">
              <div fxLayout="row" fxLayoutAlign="space-between start">
                <div fxLayout="column">
                  <div fxLayoutAlign="start center">
                    <h3 class="mat-body-2">{{menuItem.serviceGroupName}}</h3>
                  </div>

                  <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="accepted-service"></div>
                    <span class="mat-caption secondary-text">Accepted on current transaction</span>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="declined-service"></div>
                    <span class="mat-caption secondary-text">Declined on current transaction</span>
                  </div>

                </div>
                <div *ngIf="menuItem.serviceGroupRate; else noPricing">
                  <h3 class="mat-body-1 secondary-text">{{ menuItem.serviceGroupRate | currency}}</h3>
                </div>
                <ng-template #noPricing>
                  <h3 class="mat-body-1 secondary-text">N/A</h3>
                </ng-template>
              </div>
              <ng-container *ngIf="!menuItem.collapsed">
                <h4 class="mat-body-1 secondary-text" *ngIf="menuItem.source === 'Kms'; else age">Sourced via odometer
                  reading.</h4>
                <ng-template #age>
                  <h4 class="mat-body-1 secondary-text">Sourced via date of service.

                  </h4>
                </ng-template>
                <ul *ngIf="menuItem.services; else loadingServices">
                  <li *ngFor="let service of menuItem.services" [@fadeInOut] class="mat-body-1 secondary-text">
                    {{service}}</li>
                </ul>
              </ng-container>
              <ng-template #loadingServices>
                <ul>
                  <li class="animated-background secondary-text h-4 w-3/5 my-1.5 mx-0 rounded"></li>
                  <li class="animated-background secondary-text h-4 w-2/5 my-1.5 mx-0 rounded"></li>
                </ul>
              </ng-template>
              <mat-divider class="my-3 ml-1"></mat-divider>
              <div class="flex flex-row" fxLayoutAlign="space-between center">
                <div>
                  <mat-form-field appearance="fill" class="text-sm">
                    <mat-label [ngClass]="{'text-red-700': !previousDealerRecommendedTechSelection[i]}">Tech/Tech Group
                    </mat-label>
                    <mat-select name="technicianGroupId" [(ngModel)]="previousDealerRecommendedTechSelection[i]"
                      required
                      [disabled]="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) || checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)">
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Tech Groups
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicianGroups | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: 'description'"
                          [value]="tg.id">
                          {{tg.description}}
                        </mat-option>
                      </mat-optgroup>
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Technicians
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicians | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | sortNamesBy: ['lastName']"
                          [value]="tg.associateId">
                          {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                        </mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.serviceGroup); else itemActioned ">
                  <button mat-icon-button
                    (click)="selectDeclinedReason(menuItem, previousDealerRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!previousDealerRecommendedTechSelection[i]"
                    [ngClass]="previousDealerRecommendedTechSelection[i]? 'text-red-700' : 'text-grey-400'">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button mat-icon-button
                    (click)="acceptService(menuItem, previousDealerRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!previousDealerRecommendedTechSelection[i]"
                    [ngClass]="previousDealerRecommendedTechSelection[i]? 'text-green-800' : 'text-grey-400'">
                    <mat-icon>check</mat-icon>
                  </button>
                </div>

                <ng-template #itemActioned>
                  <ng-container *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)">
                    <button mat-icon-button (click)="removeAcceptedService(menuItem, data.quoteLines)"
                      class="text-green-800">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup);">
                    <button mat-icon-button (click)="removeDeclinedService(menuItem, data.quoteLines)" class="text-red">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>
                </ng-template>
              </div>

            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container id="current-container">
        <div id="current-header" fxLayoutAlign="space-between start">
          <h2>Current Services</h2>
          <button mat-icon-button class="mr-1" (click)="currentUi.collapsed = !currentUi.collapsed">
            <mat-icon>{{currentUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
          </button>
        </div>

        <ng-container id="previous-data" *ngIf="!currentUi.collapsed">
          <div class="my-2 mx-2" fxLayoutAlign="space-between center">
            <span class="mat-subheading-2 font-medium mb-0">Factory Recommended</span>
          </div>

          <ng-container *ngIf="data?.scheduleData?.toyotaMenuData?.current?.factoryRecommended; else loading">
            <div fxLayout="column"
              *ngFor="let menuItem of data.scheduleData?.toyotaMenuData.current.factoryRecommended | orderBy: [''];let i=index"
              class="testing-concept" class="qcontainer"
              style="overflow:hidden;page-break-before:always;border-radius:8px;padding:8px 16px;background-color:#FFF;margin: 12px 12px 12px 16px;">
              <div fxLayout="row" fxLayoutAlign="space-between start">
                <div fxLayout="column">
                  <div fxLayoutAlign="start center">
                    <h3 class="mat-body-2">{{menuItem.serviceGroupName}}</h3>
                  </div>

                  <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="accepted-service"></div>
                    <span class="mat-caption secondary-text">Accepted on current transaction</span>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="declined-service"></div>
                    <span class="mat-caption secondary-text">Declined on current transaction</span>
                  </div>

                </div>
                <div *ngIf="menuItem.serviceGroupRate; else noPricing">
                  <h3 class="mat-body-1 secondary-text">{{ menuItem.serviceGroupRate | currency}}</h3>
                </div>
                <ng-template #noPricing>
                  <h3 class="mat-body-1 secondary-text">N/A</h3>
                </ng-template>
              </div>
              <ng-container *ngIf="!menuItem.collapsed">
                <h4 class="mat-body-1 secondary-text" *ngIf="menuItem.source === 'Kms'; else age">Sourced via odometer
                  reading.</h4>
                <ng-template #age>
                  <h4 class="mat-body-1 secondary-text">Sourced via date of service.</h4>
                </ng-template>
                <ul *ngIf="menuItem.services; else loadingServices">
                  <li *ngFor="let service of menuItem.services" [@fadeInOut] class="mat-body-1 secondary-text">
                    {{service}}</li>
                </ul>
              </ng-container>
              <ng-template #loadingServices>
                <ul>
                  <li class="animated-background secondary-text h-4 w-3/5 my-1.5 mx-0 rounded"></li>
                  <li class="animated-background secondary-text h-4 w-2/5 my-1.5 mr-0 rounded"></li>
                </ul>
              </ng-template>
              <mat-divider class="my-3 ml-1"></mat-divider>
              <div class="flex flex-row" fxLayoutAlign="space-between center">
                <div>
                  <mat-form-field appearance="fill" class="text-sm">
                    <mat-label [ngClass]="{'text-red-700': !currentFactoryRecommendedTechSelection[i]}">Tech/Tech Group
                    </mat-label>
                    <mat-select name="technicianGroupId" [(ngModel)]="currentFactoryRecommendedTechSelection[i]"
                      required
                      [disabled]="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) || checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)">
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Tech Groups
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicianGroups | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: 'description'"
                          [value]="tg.id">
                          {{tg.description}}
                        </mat-option>
                      </mat-optgroup>
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Technicians
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicians | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | sortNamesBy: ['lastName']"
                          [value]="tg.associateId">
                          {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                        </mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.serviceGroup); else itemActioned ">
                  <button mat-icon-button
                    (click)="selectDeclinedReason(menuItem, currentFactoryRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!currentFactoryRecommendedTechSelection[i]"
                    [ngClass]="currentFactoryRecommendedTechSelection[i]? 'text-red-700' : 'text-grey-400'">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button mat-icon-button
                    (click)="acceptService(menuItem, currentFactoryRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!currentFactoryRecommendedTechSelection[i]"
                    [ngClass]="currentFactoryRecommendedTechSelection[i]? 'text-green-800' : 'text-grey-400'">
                    <mat-icon>check</mat-icon>
                  </button>

                </div>

                <ng-template #itemActioned>
                  <ng-container *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)">
                    <button mat-icon-button (click)="removeAcceptedService(menuItem, data.quoteLines)"
                      class="text-green-700">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup);">
                    <button mat-icon-button (click)="removeDeclinedService(menuItem, data.quoteLines)" class="text-red">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </ng-container>

          <div class="my-2 mx-2" fxLayoutAlign="space-between center">
            <span class="mat-subheading-2 font-medium mb-0">Dealer Recommended</span>
          </div>

          <ng-container *ngIf="data?.scheduleData?.toyotaMenuData?.current?.dealerRecommended; else loading">
            <div fxLayout="column"
              *ngFor="let menuItem of data.scheduleData?.toyotaMenuData.current.dealerRecommended | orderBy: [''];let i=index"
              class="testing-concept" class="qcontainer overflow-hidden rounded-lg py-2 px-4 my-3 mr-3 ml-4 bg-white"
              style="page-break-before:always;">
              <div fxLayout="row" fxLayoutAlign="space-between start">
                <div fxLayout="column">
                  <div fxLayoutAlign="start center">
                    <h3 class="mat-body-2">{{menuItem.serviceGroupName}}</h3>
                  </div>

                  <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="accepted-service"></div>
                    <span class="mat-caption secondary-text">Accepted on current transaction</span>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="declined-service"></div>
                    <span class="mat-caption secondary-text">Declined on current transaction</span>
                  </div>

                </div>
                <div *ngIf="menuItem.serviceGroupRate; else noPricing">
                  <h3 class="mat-body-1 secondary-text">{{ menuItem.serviceGroupRate | currency}}</h3>
                </div>
                <ng-template #noPricing>
                  <h3 class="mat-body-1 secondary-text">N/A</h3>
                </ng-template>
              </div>
              <ng-container *ngIf="!menuItem.collapsed">
                <h4 class="mat-body-1 secondary-text" *ngIf="menuItem.source === 'Kms'; else age">Sourced via odometer
                  reading.</h4>
                <ng-template #age>
                  <h4 class="mat-body-1 secondary-text">Sourced via date of service.</h4>
                </ng-template>
                <ul *ngIf="menuItem.services; else loadingServices">
                  <li *ngFor="let service of menuItem.services" [@fadeInOut] class="mat-body-1 secondary-text">
                    {{service}}</li>
                </ul>
              </ng-container>
              <ng-template #loadingServices>
                <ul>
                  <li class="animated-background secondary-text h-4 w-3/5 my-1.5 mx-0 rounded"></li>
                  <li class="animated-background secondary-text h-4 w-2/5 my-1.5 mx-0 rounded"></li>
                </ul>
              </ng-template>
              <mat-divider class="my-3 ml-1"></mat-divider>
              <div class="flex flex-row" fxLayoutAlign="space-between center">
                <div>
                  <mat-form-field appearance="fill" class="text-sm">
                    <mat-label [ngClass]="{'text-red-700': !currentDealerRecommendedTechSelection[i]}">Tech/Tech Group
                    </mat-label>
                    <mat-select name="technicianGroupId" [(ngModel)]="currentDealerRecommendedTechSelection[i]" required
                      [disabled]="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) || checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)">
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Tech Groups
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicianGroups | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: 'description'"
                          [value]="tg.id">
                          {{tg.description}}
                        </mat-option>
                      </mat-optgroup>
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Technicians
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicians | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | sortNamesBy: ['lastName']"
                          [value]="tg.associateId">
                          {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                        </mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.serviceGroup); else itemActioned ">
                  <button mat-icon-button
                    (click)="selectDeclinedReason(menuItem, currentDealerRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!currentDealerRecommendedTechSelection[i]"
                    [ngClass]="currentDealerRecommendedTechSelection[i]? 'text-red-700' : 'text-grey-400'">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button mat-icon-button
                    (click)="acceptService(menuItem, currentDealerRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!currentDealerRecommendedTechSelection[i]"
                    [ngClass]="currentDealerRecommendedTechSelection[i]? 'text-green-800' : 'text-grey-400'">
                    <mat-icon>check</mat-icon>
                  </button>
                </div>

                <ng-template #itemActioned>
                  <ng-container *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)">
                    <button mat-icon-button (click)="removeAcceptedService(menuItem, data.quoteLines)"
                      class="text-green-700">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup);">
                    <button mat-icon-button (click)="removeDeclinedService(menuItem, data.quoteLines)"
                      class="text-red-700">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container id="future-container">
        <div id="future-header" fxLayoutAlign="space-between start">
          <h2>Future Services</h2>
          <button mat-icon-button class="mr-1" (click)="futureUi.collapsed = !futureUi.collapsed">
            <mat-icon>{{futureUi.collapsed ? 'keyboard_arrow_down' : 'keyboard_arrow_up'}}</mat-icon>
          </button>
        </div>

        <ng-container id="previous-data" *ngIf="!futureUi.collapsed">
          <div class="my-2 mx-2" fxLayoutAlign="space-between center">
            <span class="mat-subheading-2 font-medium mb-0">Factory Recommended</span>
          </div>

          <ng-container *ngIf="data?.scheduleData?.toyotaMenuData?.future?.factoryRecommended; else loading">
            <div fxLayout="column"
              *ngFor="let menuItem of data.scheduleData?.toyotaMenuData.future.factoryRecommended | orderBy: [''];let i=index"
              class="testing-concept" class="qcontainer"
              style="overflow:hidden;page-break-before:always;border-radius:8px;padding:8px 16px;background-color:#FFF;margin: 12px 12px 12px 16px;">
              <div fxLayout="row" fxLayoutAlign="space-between start">
                <div fxLayout="column">
                  <div fxLayoutAlign="start center">
                    <h3 class="mat-body-2">{{menuItem.serviceGroupName}}</h3>
                  </div>

                  <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="accepted-service"></div>
                    <span class="mat-caption secondary-text">Accepted on current transaction</span>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="declined-service"></div>
                    <span class="mat-caption secondary-text">Declined on current transaction</span>
                  </div>

                </div>
                <div *ngIf="menuItem.serviceGroupRate; else noPricing">
                  <h3 class="mat-body-1 secondary-text">{{ menuItem.serviceGroupRate | currency}}</h3>
                </div>
                <ng-template #noPricing>
                  <h3 class="mat-body-1 secondary-text">N/A</h3>
                </ng-template>
              </div>
              <ng-container *ngIf="!menuItem.collapsed">
                <h4 class="mat-body-1 secondary-text" *ngIf="menuItem.source === 'Kms'; else age">Sourced via odometer
                  reading.</h4>
                <ng-template #age>
                  <h4 class="mat-body-1 secondary-text">Sourced via date of service.</h4>
                </ng-template>
                <ul *ngIf="menuItem.services; else loadingServices">
                  <li *ngFor="let service of menuItem.services" [@fadeInOut] class="mat-body-1 secondary-text">
                    {{service}}</li>
                </ul>
              </ng-container>
              <ng-template #loadingServices>
                <ul>
                  <li class="animated-background secondary-text h-4 w-3/5 my-1.5 mx-0 rounded"></li>
                  <li class="animated-background secondary-text h-4 w-2/5 my-1.5 mx-0 rounded"></li>
                </ul>
              </ng-template>
              <mat-divider class="my-3 ml-1"></mat-divider>
              <div class="flex flex-row" fxLayoutAlign="space-between center">
                <div>
                  <mat-form-field appearance="fill" class="text-sm">
                    <mat-label [ngClass]="{'text-red-700': !futureFactoryRecommendedTechSelection[i]}">Tech/Tech Group
                    </mat-label>
                    <mat-select name="technicianGroupId" [(ngModel)]="futureFactoryRecommendedTechSelection[i]" required
                      [disabled]="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) || checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)">
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Tech Groups
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicianGroups | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | orderBy: 'description'"
                          [value]="tg.id">
                          {{tg.description}}
                        </mat-option>
                      </mat-optgroup>
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Technicians
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicians | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | sortNamesBy: ['lastName']"
                          [value]="tg.associateId">
                          {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                        </mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.serviceGroup); else itemActioned ">
                  <button mat-icon-button
                    (click)="selectDeclinedReason(menuItem, futureFactoryRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!futureFactoryRecommendedTechSelection[i]"
                    [ngClass]="futureFactoryRecommendedTechSelection[i]? 'text-red-700' : 'text-grey-400'">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button mat-icon-button
                    (click)="acceptService(menuItem, futureFactoryRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!futureFactoryRecommendedTechSelection[i]"
                    [ngClass]="futureFactoryRecommendedTechSelection[i]? 'text-green-800' : 'text-grey-400'">
                    <mat-icon>check</mat-icon>
                  </button>
                </div>

                <ng-template #itemActioned>
                  <ng-container *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)">
                    <button mat-icon-button (click)="removeAcceptedService(menuItem, data.quoteLines)"
                      class="text-green-800">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup);">
                    <button mat-icon-button (click)="removeDeclinedService(menuItem, data.quoteLines)"
                      class="text-red-700">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </ng-container>

          <div class="my-2 mx-2" fxLayoutAlign="space-between center">
            <span class="mat-subheading-2 font-medium mb-0">Dealer Recommended</span>
          </div>

          <ng-container *ngIf="data?.scheduleData?.toyotaMenuData?.future?.dealerRecommended; else loading">
            <div fxLayout="column"
              *ngFor="let menuItem of data.scheduleData?.toyotaMenuData.future.dealerRecommended | orderBy: [''];let i=index"
              class="testing-concept" class="qcontainer"
              style="overflow:hidden;page-break-before:always;border-radius:8px;padding:8px 16px;background-color:#FFF;margin: 12px 12px 12px 16px;">
              <div class="flex flex-row" fxLayoutAlign="space-between start">
                <div class="flex flex-col">
                  <div fxLayoutAlign="start center">
                    <h3 class="mat-body-2">{{menuItem.serviceGroupName}}</h3>
                  </div>

                  <div *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="accepted-service"></div>
                    <span class="mat-caption secondary-text">Accepted on current transaction</span>
                  </div>
                  <div *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)" fxLayout="row"
                    fxLayoutAlign="start center">
                    <div class="declined-service"></div>
                    <span class="mat-caption secondary-text">Declined on current transaction</span>
                  </div>

                </div>
                <div *ngIf="menuItem.serviceGroupRate; else noPricing">
                  <h3 class="mat-body-1 secondary-text">{{ menuItem.serviceGroupRate | currency}}</h3>
                </div>
                <ng-template #noPricing>
                  <h3 class="mat-body-1 secondary-text">N/A</h3>
                </ng-template>
              </div>
              <ng-container *ngIf="!menuItem.collapsed">
                <h4 class="mat-body-1 secondary-text" *ngIf="menuItem.source === 'Kms'; else age">Sourced via odometer
                  reading.</h4>
                <ng-template #age>
                  <h4 class="mat-body-1 secondary-text">Sourced via date of service.</h4>
                </ng-template>
                <ul *ngIf="menuItem.services; else loadingServices">
                  <li *ngFor="let service of menuItem.services" [@fadeInOut] class="mat-body-1 secondary-text">
                    {{service}}</li>
                </ul>
              </ng-container>
              <ng-template #loadingServices>
                <ul>
                  <li class="animated-background secondary-text h-4 w-3/5 my-1.5 mx-0 rounded"></li>
                  <li class="animated-background secondary-text h-4 w-2/5 my-1.5 mx-0 rounded"></li>
                </ul>
              </ng-template>
              <mat-divider class="my-3 ml-1"></mat-divider>
              <div class="flex flex-row" fxLayoutAlign="space-between center">
                <div>
                  <mat-form-field appearance="fill" class="text-sm">
                    <mat-label [ngClass]="{'text-red-700': !futureDealerRecommendedTechSelection[i]}">Tech/Tech
                      Group</mat-label>
                    <mat-select name="technicianGroupId" [(ngModel)]="futureDealerRecommendedTechSelection[i]" required
                      [disabled]="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) || checkServiceGroupStatus('saved-declined', menuItem.serviceGroup)">
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Tech Groups
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicianGroups | filterBy: ['rooftopId']: data.currentEmployee.rooftopId"
                          [value]="tg.id">
                          {{tg.description}}
                        </mat-option>
                      </mat-optgroup>
                      <mat-optgroup>
                        <label fxFlex class="w-full">
                          Technicians
                        </label>
                        <mat-option
                          *ngFor="let tg of data.dropdowns.technicians | filterBy: ['rooftopId']: data.currentEmployee.rooftopId | sortNamesBy: ['lastName']"
                          [value]="tg.associateId">
                          {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                        </mat-option>
                      </mat-optgroup>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div
                  *ngIf="!checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup) && !checkServiceGroupStatus('saved-declined', menuItem.serviceGroup); else itemActioned ">
                  <button mat-icon-button
                    (click)="selectDeclinedReason(menuItem, futureDealerRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!futureDealerRecommendedTechSelection[i]"
                    [ngClass]="futureDealerRecommendedTechSelection[i]? 'text-red-700' : 'text-grey-400'">
                    <mat-icon>clear</mat-icon>
                  </button>
                  <button mat-icon-button
                    (click)="acceptService(menuItem, futureDealerRecommendedTechSelection[i], data.dropdowns.technicians, data.dropdowns.technicianGroups)"
                    [disabled]="!futureDealerRecommendedTechSelection[i]"
                    [ngClass]="futureDealerRecommendedTechSelection[i]? 'text-green-800' : 'text-grey-400'">
                    <mat-icon>check</mat-icon>
                  </button>
                </div>

                <ng-template #itemActioned>
                  <ng-container *ngIf="checkServiceGroupStatus('saved-accepted', menuItem.serviceGroup)">
                    <button mat-icon-button (click)="removeAcceptedService(menuItem, data.quoteLines)"
                      style="color:#2E7D32">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>

                  <ng-container *ngIf="checkServiceGroupStatus('saved-declined', menuItem.serviceGroup);">
                    <button mat-icon-button (click)="removeDeclinedService(menuItem, data.quoteLines)" class="text-red">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-template #loading>
        <div class="qcontainer"
          style="page-break-before:always;border-radius:8px;padding:24px 16px 16px 16px;background-color:#FFF;margin-bottom:12px;"
          *ngFor="let placeholder of [1,2,3,4]">
          <div class="flex flex-row" fxLayoutAlign="space-between start">
            <h3 class="animated-background h-5 w-2/5 my-1.5 mx-0 rounded"></h3>
            <h3 class="animated-background h-4 w-7 my-1.5 mx-0 rounded"></h3>
          </div>
          <h3 class="animated-background h-5 w-1/3 my-1.5 mx-0 rounded"></h3>
          <ul class="mt-5 mr-0 mb-3 ml-0">
            <li class="animated-background secondary-text h-4 w-3/5 my-1.5 mx-0 rounded"></li>
            <li class="animated-background secondary-text h-4 w-2/5 my-1.5 mx-0 rounded"></li>
          </ul>
          <mat-divider class="my-0 -mr-4 ml-1"></mat-divider>
          <div class="flex flex-row" fxLayoutAlign="space-between center">
            <div>
              <button mat-icon-button [disabled]="true">
                <mat-icon>view_list</mat-icon>
              </button>
            </div>
            <div>
              <button mat-icon-button [disabled]="true">
                <mat-icon>add_circle_outline</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <ng-template #menuUnavailable>
    <ng-container *ngIf="data?.scheduleData?.vehicle?.deliveryDate !== null; else noDeliveryDate">
      <span fxLayoutAlign="center center">Menu data could not be loaded. Please try again.</span>
    </ng-container>
  </ng-template>
  <ng-template #noDeliveryDate>
    <span fxLayoutAlign="center center">This vehicle currently has no in-service date. Please edit the vehicle details
      and enter an in-service date to view Menu data.</span>
  </ng-template>
</div>